import { Collapse as AntdCollapse } from 'antd';
import React from 'react';

const Collapse = ({ items = [] }) => {
  return <AntdCollapse items={items} />;
};

export default Collapse;
